/**
 * 统一 AI 调用函数
 * ================
 * 所有工具都通过这个函数调用 AI，
 * 前端调用 /api/proxy，服务端转发到真实 AI API
 * API Key 永远不暴露给浏览器
 */

const IS_DEV = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

export async function callAI(messages, system = "", maxTokens = 3000, provider = "qwen") {
  // 开发环境直接调 Anthropic（Claude.ai artifact 环境也走这里）
  // 生产环境走 /api/proxy 服务端代理
  if (IS_DEV && window.__ANTHROPIC_DIRECT__) {
    const res = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ model: "claude-sonnet-4-20250514", max_tokens: maxTokens, system, messages }),
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.error?.message || "AI请求失败"); }
    const d = await res.json();
    return d.content?.find(b => b.type === "text")?.text || "";
  }

  // 生产模式：走服务端代理
  const res = await fetch("/api/proxy", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ messages, system, maxTokens, provider }),
  });

  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.error || "AI代理请求失败");
  }

  const d = await res.json();
  return d.text || "";
}

export function safeJSON(raw) {
  const c = raw.replace(/```json\s*/gi, "").replace(/```\s*/g, "").trim();
  try { return JSON.parse(c); } catch {
    const m = c.match(/\{[\s\S]*\}/);
    if (m) return JSON.parse(m[0]);
    throw new Error("JSON解析失败");
  }
}
